import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./questionMatch.css";
import { connect } from "react-redux";
import Navbar from "../../components/navbar";
import QuestionView from "./questionView";
import {
  getVisioQuestion,
  saveVisioQuestion,
  getVisioActivitySummary,
} from "../../services/apiService";
import Loading from "carbon-components-react/lib/components/Loading";
import { trackPageView, trackEvent } from "../../services/analyticsService";
import MatchView from "./matchView";
import Timer from "../../components/timer";
import KeyboardEventHandler from "react-keyboard-event-handler";
import { toastTheError } from "../../services/toastService";

export function QuestionMatch(props) {
  const [inProgress, setInProgress] = useState(false);
  const [question, setQuestion] = useState(null);
  const [noQuestion, setNoQuestion] = useState(false);
  const [unavailable, setUnavailable] = useState(false);
  const [disableUI, setDisableUI] = useState(false);
  const [stats, setStats] = useState({});
  const { t } = useTranslation("kunduz");

  useEffect(() => {
    if (props.teacher && props.teacher.is_available) {
      retrieveQuestion();
      refreshStats();
    }
    trackPageView("/questionMatch");
  }, []);

  useEffect(() => {
    if (props.teacher && props.teacher.is_available) {
      setUnavailable(false);
      retrieveQuestion();
    } else {
      setUnavailable(true);
      setQuestion(null);
    }
  }, [props.teacher]);

  function refreshStats() {
    getVisioActivitySummary()
      .then((data) => {
        setStats(data.results[0]);
      })
      .catch((error) => {
        console.warn(error);
      });
  }

  function playDing() {
    try {
      // only play for india
      const { teacher } = props;
      if (!teacher) return;
      if (teacher?.phone_number?.country_code != 1) {
        let audio = new Audio(
          "https://ia800203.us.archive.org/14/items/slack_sfx/b2.mp3"
        );
        audio.play();
      }
    } catch (error) {}
  }

  function retrieveQuestion(shouldDing = false) {
    setInProgress(true);
    setQuestion(null);
    setUnavailable(false);

    getVisioQuestion()
      .then((question) => {
        if (question != "") {
          question.similar_question.rate = question.rate;
          question.similar_question.qid = question.id;

          setQuestion(question);
          setInProgress(false);
          setNoQuestion(false);
          setDisableUI(false);

          shouldDing && playDing();
        } else {
          setInProgress(false);
          setNoQuestion(true);
          setDisableUI(false);
        }
      })
      .catch((error) => {
        setInProgress(false);
        setDisableUI(false);
        setNoQuestion(true);
        toastTheError(error);
      });
  }

  function match(id) {
    setDisableUI(true);
    saveVisioQuestion(id, {
      status: "matched",
    })
      .then(() => {
        retrieveQuestion();
      })
      .catch((error) => {
        retrieveQuestion();
        toastTheError(error);
      })
      .finally(() => {
        setDisableUI(false);
        refreshStats();
      });
  }

  function dontMatch(id) {
    setDisableUI(true);
    saveVisioQuestion(id, {
      status: "rejected",
    })
      .then(() => {
        retrieveQuestion();
      })
      .catch((error) => {
        retrieveQuestion();
        toastTheError(error);
      })
      .finally(() => {
        setDisableUI(false);
        refreshStats();
      });
  }

  function hotKeyListener(e) {
    switch (e.key) {
      case "m":
        match(question.id);
        break;
      case "n":
        dontMatch(question.id);
        break;
      default:
        break;
    }
  }

  function renderLoading() {
    return (
      <div className="loading-wrapper">
        <Loading withOverlay={false} />
        <div>{t("retrievingQuestion")}</div>
      </div>
    );
  }

  function renderNoQuestion() {
    return (
      <div
        className="flex-aic"
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 100,
          paddingBottom: 100,
        }}
      >
        <div>{t("noQuestionFound")}</div>
        <Timer
          expireCallback={() => {
            retrieveQuestion(true);
          }}
        />
      </div>
    );
  }

  function renderMiniStats() {
    if (stats && stats.data) {
      return (
        <div
          style={{
            padding: "10px 16px",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div>İncelenen Veri: {stats.data.question_review.count}</div>
          <div>Kazanç: {stats.data.question_review.earning}</div>
        </div>
      );
    } else {
      return <></>;
    }
  }

  function renderQuestion() {
    return (
      <>
        {renderMiniStats()}
        <div className="question-wrapper">
          <QuestionView
            inProgress={disableUI}
            question={question && question.question}
            preview={false}
            side="left"
          />
        </div>
        <div className="match-wrapper">
          <MatchView
            inProgress={disableUI}
            question={question && question.similar_question}
            stats={question && question.meta}
            dontMatchCallback={(id) => {
              dontMatch(id);
            }}
            matchCallback={(id) => {
              match(id);
            }}
            side="right"
          />
        </div>
      </>
    );
  }

  function renderUnavailable() {
    return (
      <div
        className="flex-aic"
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 100,
          paddingBottom: 100,
        }}
      >
        <div>{t("activateMatchStatus")}</div>
      </div>
    );
  }

  if (!props.teacher) {
    return <Redirect to="/login" />;
  }
  return (
    <div className="view">
      <Navbar />
      <div className="question-match-view">
        <div className="content-wrapper">
          {unavailable
            ? renderUnavailable()
            : inProgress
            ? renderLoading()
            : noQuestion
            ? renderNoQuestion()
            : renderQuestion()}
        </div>
      </div>
      <KeyboardEventHandler
        handleKeys={["m", "n"]}
        onKeyEvent={(key, e) => {
          hotKeyListener({ key });
        }}
      />
    </div>
  );
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    teacher: state.teacher,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionMatch);
